import { validateSession } from './sessionAuth'

export async function ensureAuthenticated(): Promise<boolean> {
  return validateSession()
}
